import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { errMsg } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [state, setState] = useState({ loading: true, ok: false, error: null });

  useEffect(() => {
    if (!token) { setState({ loading: false, ok: false, error: "Token mancante" }); return; }
    (async () => {
      try {
        await api.post("/auth/verify-email", { token });
        setState({ loading: false, ok: true, error: null });
      } catch (e) {
        setState({ loading: false, ok: false, error: errMsg(e, "Verifica fallita") });
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-zen-bg flex items-center justify-center px-6 py-12" data-testid="verify-email-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center mb-8">
          <img src="/brand/freelanzen-wordmark.png" alt="FreelanZen" className="h-10 w-auto object-contain"/>
        </Link>
        <div className="zen-card p-8 text-center">
          {state.loading ? (
            <>
              <Loader2 size={40} className="mx-auto text-zen-primary mb-3 animate-spin"/>
              <p className="text-zen-ink2">Sto verificando l&apos;email…</p>
            </>
          ) : state.ok ? (
            <>
              <CheckCircle2 size={48} className="mx-auto text-zen-primary mb-3"/>
              <h2 className="font-heading text-2xl mb-2">Email verificata!</h2>
              <p className="text-zen-ink2 text-sm">Il tuo account è ora completamente attivo.</p>
              <Link to="/dashboard" className="mt-6 inline-block bg-zen-primary hover:bg-zen-primaryHover text-white rounded-full py-3 px-6 text-sm">
                Vai al Dashboard
              </Link>
            </>
          ) : (
            <>
              <XCircle size={48} className="mx-auto text-zen-alert mb-3"/>
              <h2 className="font-heading text-2xl mb-2">Verifica fallita</h2>
              <p className="text-zen-ink2 text-sm">{state.error}</p>
              <Link to="/dashboard" className="mt-6 inline-block text-zen-primary hover:underline text-sm">
                Vai al Dashboard e richiedi un nuovo link
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
